import filter from 'lodash/filter';
import _ from 'lodash';
import queryString from 'querystring';

export const getQueryParams = () => {
    const queryParams = location.search;
    const query = queryParams.replace('?', '');
    return queryString.parse(query);
};

export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function getAlphaNumericCharacters() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
}

export function invalidCharaters() {
    return '^[^!@#$%^&+={}/?<>]+$';
}

export function invalidEmailCharaters() {
    return '^[^()<>,;:\\/"{}]+$';
}

export function isValidEmail(emailAddress) {
    const re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    return re.test(emailAddress);
}

export function getSchoolPreferenceNameFormats(nameFormats) {
    const options = nameFormats.availableOptions.map(item => ({
        id: item.value,
        name: item.text,
        isDefault: nameFormats.preferredValue === item.value
    }));

    return options;
}

export const searchByProperty = (collection, needleObj) => filter(collection, needleObj);

export const searchByText = (collection, text, exclude = ['id']) => {
    const filterWithByProperty = exclude.length > 0 ? _.omit : _.omit;
    return _.filter(collection, _.flow(
        _.partial(filterWithByProperty, _, exclude),
        _.partial(
            _.some, _,
            _.flow(_.toLower, _.partial(_.includes, _, _.toLower(text), 0))
        )
    ));
};


export const getProductList = (id = null) => {
    const products = [
        { id: 1, name: 'Mathletics' },
        { id: 10, name: 'Spelling' },
        { id: 11, name: 'Writing' }
    ];
    if (id === null) {
        return products;
    }
    const product = products.filter(p => p.id === id);
    const name = product[0] !== undefined ? product[0].name : '';
    return name;
};



// WEBPACK FOOTER //
// ./app/helpers/utils.js